import { NavigateFunction } from "react-router-dom";
import { routePathByName } from "@/app/routes";

/**
 * Handle navigation for sidebar items
 * 
 * @param url The URL to navigate to
 * @param navigate React Router's navigate function
 * @param event Optional click event to prevent default behavior
 * @param routeName Optional route name to use with routePathByName
 * @param params Optional parameters for named routes
 */
export const handleNavigation = (
  url: string, 
  navigate: NavigateFunction, 
  event?: React.MouseEvent, 
  routeName?: string,
  params?: Record<string, string>
) => {
  if (event) {
    event.preventDefault();
    // eslint-disable-next-line no-console
    console.log('[handleNavigation] called', { url, routeName, eventType: event.type, defaultPrevented: event.defaultPrevented });
  }

  let targetUrl = url;
  let resolvedFromRouteName = false;
  if (routeName) {
    const resolved = routePathByName(routeName, params);
    // Debug logging
    // eslint-disable-next-line no-console
    console.log('[handleNavigation] routeName:', routeName, 'resolved:', resolved, 'url:', url);
    if (resolved && resolved !== '/not-found') {
      targetUrl = resolved;
      resolvedFromRouteName = true;
    }
  }

  if (
    targetUrl.endsWith('.html') || 
    targetUrl.startsWith('http') || 
    targetUrl.startsWith('https') ||
    targetUrl === '#' || 
    window.location.pathname.includes('.html')
  ) {
    if (targetUrl.startsWith('http') || targetUrl.startsWith('https')) {
      window.open(targetUrl, '_blank');
    } else if (targetUrl !== '#') {
      window.location.href = targetUrl;
    }
  } else if (resolvedFromRouteName) {
    // Only use navigate for valid routeName resolution
    navigate(targetUrl);
  } else {
    // Fallback: if no valid routeName, treat as hard navigation
    window.location.href = targetUrl;
  }
};
